/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';
import { ORDER_STATUS_SORT } from '../constants/Orders';

export function renderData(row) {
	const white = row.trimStart();
	const [plant, state] = white.split(', ');
	const [firstData, secondData] = plant.split('-');
	const [plants] = plant.split(',');
	const newPlant = plants
		.split(' ')
		.map((w) => w[0]?.toUpperCase() + w.substring(1)?.toLowerCase())
		.join(' ');

	if (state && firstData && secondData) {
		return (
			<>
				<span>
					{firstData}
					<span>-</span>
					{secondData}
				</span>
				<span className="caps">, {state}</span>
			</>
		);
	} else if (state && firstData) {
		return (
			<>
				<span>{firstData}</span>
				<span className="caps">, {state}</span>
			</>
		);
	}
	const plantFormatted = newPlant
		.replace(' | ', ', ')
		.replace(' | ', ', ')
		.replace(' | ', ', ');
	return plantFormatted;
}

export function sortFunction(a, b) {
	const indexA = ORDER_STATUS_SORT.indexOf(a.Order_Status);
	const indexB = ORDER_STATUS_SORT.indexOf(b.Order_Status);
	if (indexA < indexB) {
		return -1;
	} else if (indexA > indexB) {
		return 1;
	}
	return 0;
}
